export default "__VITE_ASSET__20ab5a58__"